import * as React from 'react'; // Use any here since we do not get the type during compilation

var SelectContext = /*#__PURE__*/React.createContext(null);
export default SelectContext;